import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { AgmMap } from '@agm/core';
import { Business } from '../models/business.model';
import { GoogleService } from '../../google/google.service';
import { LatLon } from '../../util/geodesy/latlon';
import { UserService } from '../../shared/user/user.service';
import { EditOverviewComponent } from '../edit-overview/edit-overview.component';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { TagService } from '../../shared/services/tag.service';
import { formatFullDate } from '../../util/datetime-utils';
import * as moment from 'moment-timezone';
import { Router } from '@angular/router';
import { hasTag } from '../../util/tag-utils';
import { BlueBoxDialogComponent } from '../blue-box-dialog/blue-box-dialog.component';
import { SuggestAChangeComponent } from '../../shared/suggest-a-change/suggest-a-change.component';
import { SelectMagazineDialogComponent } from '../select-magazine-dialog/select-magazine-dialog.component';
var BusinessOverviewComponent = /** @class */ (function () {
    function BusinessOverviewComponent(_google, _userService, _cdref, _editContactDialog, _toggleService, _businessManagerService, snackBar, _tagService, _router, _blueBoxDialog, _suggestAChangeDialog, _selectMagazineDialog, _snackBar) {
        this._google = _google;
        this._userService = _userService;
        this._cdref = _cdref;
        this._editContactDialog = _editContactDialog;
        this._toggleService = _toggleService;
        this._businessManagerService = _businessManagerService;
        this.snackBar = snackBar;
        this._tagService = _tagService;
        this._router = _router;
        this._blueBoxDialog = _blueBoxDialog;
        this._suggestAChangeDialog = _suggestAChangeDialog;
        this._selectMagazineDialog = _selectMagazineDialog;
        this._snackBar = _snackBar;
        this.isBusinessManager = false;
        this.isFlyingClub = false;
        this.showMap = false;
        this.latlonApprox = false;
        this.editModeSet = false;
        this.adminDate = null;
        this.ADMIN_ID = 49035;
        this.TIME_ZONE = 'America/New_York';
        this.ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        this.isAmbassador = false;
        this.isRegionalManager = false;
        this.isFlightSchool = false;
        this.isFbo = false;
    }
    BusinessOverviewComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var address, _a, _b, _c, _d;
            var _this = this;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (this.business.location) {
                            this.latlon = new LatLon(this.business.location.lat, this.business.location.lon);
                            this.showMap = true;
                        }
                        else if (this.business.address) {
                            address = this.business.address.formatAddress(true);
                            if (address) {
                                this.geocode(address);
                            }
                        }
                        this._toggleService.toggleEmitter.subscribe(function (isOn) {
                            _this.editModeSet = isOn;
                        });
                        _a = this;
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 1:
                        _a.isBusinessManager = _e.sent();
                        this.business.tags.map(function (tag) {
                            if (tag.tagId === _this.ADMIN_ID) {
                                _this.adminDate = moment.tz(tag.updateDate, _this.TIME_ZONE);
                                return;
                            }
                            else if (tag.tagName === 'Flying Club') {
                                _this.isFlyingClub = true;
                            }
                        });
                        if (!(hasTag(this.business.tags, 'Flying Club') && this.business.flyingClub)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, this._businessManagerService.isAmbassador()];
                    case 2:
                        _b.isAmbassador = _e.sent();
                        _e.label = 3;
                    case 3:
                        _c = this;
                        return [4 /*yield*/, this._businessManagerService.isRegionalManager()];
                    case 4:
                        _d = (_e.sent());
                        if (!_d) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._businessManagerService.userOwnsBusiness(this.business.id)];
                    case 5:
                        _d = !(_e.sent());
                        _e.label = 6;
                    case 6:
                        _c.isRegionalManager = _d;
                        this.isFlightSchool = (!this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training::Private'); })
                            && this.business.tags.some(function (t) { return t.tagName.startsWith('Flight Training'); }));
                        this.isFbo = hasTag(this.business.tags, 'Admin::BusinessIsFbo');
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessOverviewComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var nativeMap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.showMap && this.latlon)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._initMap()];
                    case 1:
                        nativeMap = _a.sent();
                        nativeMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    BusinessOverviewComponent.prototype._initMap = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.map.mapReady.subscribe(function (map) {
                            _this._nativeMap = map;
                            resolve(map);
                        }, function (err) { return reject(err); });
                    })];
            });
        });
    };
    Object.defineProperty(BusinessOverviewComponent.prototype, "BusinessWebAddress", {
        get: function () {
            if (this.business.webAddress.indexOf('http://') >= 0 || this.business.webAddress.indexOf('https://') >= 0) {
                return this.business.webAddress;
            }
            else {
                return 'http://' + this.business.webAddress;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BusinessOverviewComponent.prototype, "BusinessEmailAddress", {
        get: function () {
            return 'mailto:' + this.business.email;
        },
        enumerable: true,
        configurable: true
    });
    BusinessOverviewComponent.prototype.geocode = function (address) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var gc, nativeMap, geom, latlon, offset, bounds;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._google.promise];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this._google.geocode({ address: address })];
                    case 2:
                        gc = _a.sent();
                        if (!gc[0]) return [3 /*break*/, 4];
                        this.latlonApprox = true;
                        this.showMap = true;
                        this._cdref.detectChanges();
                        return [4 /*yield*/, this._initMap()];
                    case 3:
                        nativeMap = _a.sent();
                        geom = gc[0].geometry;
                        switch (geom.location_type) {
                            case google.maps.GeocoderLocationType.ROOFTOP:
                            case google.maps.GeocoderLocationType.RANGE_INTERPOLATED:
                                this.latlon = new LatLon(geom.location.lat(), geom.location.lng());
                                nativeMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                                break;
                            case google.maps.GeocoderLocationType.GEOMETRIC_CENTER:
                                latlon = new LatLon(geom.location.lat(), geom.location.lng());
                                nativeMap.setCenter({ lat: latlon.lat, lng: latlon.lon });
                                offset = 0.08;
                                bounds = new google.maps.LatLngBounds();
                                bounds.extend(new google.maps.LatLng(latlon.lat + offset, latlon.lon + offset));
                                bounds.extend(new google.maps.LatLng(latlon.lat - offset, latlon.lon - offset));
                                nativeMap.fitBounds(bounds);
                                break;
                            default:
                                if (geom.bounds) {
                                    // When only approximate location is available, use bounds instead of lat/lon
                                    this.bounds = geom.bounds.toJSON();
                                    nativeMap.fitBounds(this.bounds);
                                }
                                else {
                                    this.showMap = false;
                                    this.latlonApprox = false;
                                }
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BusinessOverviewComponent.prototype.onWindowResize = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.map && this._nativeMap)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.map.triggerResize()];
                    case 1:
                        _a.sent();
                        if (this.latlon) {
                            this._nativeMap.setCenter({ lat: this.latlon.lat, lng: this.latlon.lon });
                        }
                        else if (this.bounds) {
                            this._nativeMap.fitBounds(this.bounds);
                        }
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * formats admin date
     * @return {string}
     */
    BusinessOverviewComponent.prototype.getAdminDate = function () {
        if (this.adminDate) {
            return formatFullDate(this.adminDate, this.TIME_ZONE);
        }
    };
    BusinessOverviewComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        data = void 0;
                        if (!(event.checked && this.adminDate)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tagService.putTag(this.ADMIN_ID, this.business.id)];
                    case 1:
                        data = _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!event.checked) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._tagService.postTag(this.ADMIN_ID, this.business.id)];
                    case 3:
                        data = _a.sent();
                        _a.label = 4;
                    case 4:
                        if (data) {
                            this.adminDate = moment.tz(data.updateDate, this.TIME_ZONE);
                            event.source.disabled = true;
                        }
                        else {
                            throw new Error('API did not return any data');
                        }
                        return [3 /*break*/, 6];
                    case 5:
                        e_1 = _a.sent();
                        this.snackBar.open(this.ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Opens modal for editing business overview section, displays snackbar if serverAPI was successfully updated.
     */
    BusinessOverviewComponent.prototype.openEditContactDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            business: this.business
        };
        dialogConfig.width = '95%';
        var dialogRef = this._editContactDialog.open(EditOverviewComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this.snackBar.open('Business Info', 'Updated', {
                    duration: 1000
                });
            }
            else {
                _this.snackBar.open(_this.ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    /**
     * Opens modal for blue box text.
     */
    BusinessOverviewComponent.prototype.openBlueBoxDialog = function (dialogType) {
        var dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            dialogType: dialogType
        };
        dialogConfig.maxWidth = '600px';
        dialogConfig.maxHeight = '500px';
        var dialogRef = this._blueBoxDialog.open(BlueBoxDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
        });
    };
    BusinessOverviewComponent.prototype.pinDropped = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.business.location && this.business.location.lat && this.business.location.lon) {
                            Object.assign(this.business.location, new LatLon(event.coords.lat, event.coords.lng));
                        }
                        else {
                            this.business.location = new LatLon(event.coords.lat, event.coords.lng);
                        }
                        return [4 /*yield*/, this._businessManagerService.updateBusiness(this.business)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    BusinessOverviewComponent.prototype.navigateToWebcams = function () {
        var tempUrl = this._router.url;
        if (this._router.url.indexOf('?') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('?'));
        }
        if (this._router.url.indexOf('#') > 0) {
            tempUrl = this._router.url.substr(0, tempUrl.indexOf('#'));
        }
        this._router.navigate([tempUrl], { fragment: 'webcams' });
    };
    BusinessOverviewComponent.prototype.openSuggestAChangeDialog = function () {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.width = '35%';
        dialogConfig.data = {
            businessID: this.business.id
        };
        var dialogRef = this._suggestAChangeDialog.open(SuggestAChangeComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('The information you have provided has been forwarded to the AOPA Airport Directory team and ' +
                    'will be reviewed as soon as possible. Thank you!', 'Success', {
                    duration: 6000
                });
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    BusinessOverviewComponent.prototype.openSelectMagDialog = function (facilityType) {
        var dialogRef = this._selectMagazineDialog.open(SelectMagazineDialogComponent, {
            disableClose: false,
            autoFocus: true,
            data: {
                business: this.business
            }
        });
    };
    return BusinessOverviewComponent;
}());
export { BusinessOverviewComponent };
